<template>
    <form ref="form" @submit.prevent="handleClickForm">
        <slot></slot>
    </form>
</template>

<script>
    export default {
        name: 'form-component',

        methods: {
            handleClickForm() {
                this.$emit('submit');
            }
        },
    }
</script>

<style scoped>

</style>
